var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRankingGraphIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ranking (1) 2",
    clipPath: "url(#clip0_134_2283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_2283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 117
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1437",
    d: "M0 1.52588e-05H117V117H0V1.52588e-05Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_2283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1443",
    d: "M73.1334 107.548H43.8665V40.5412C43.8665 39.7281 44.5255 39.0691 45.3383 39.0691H71.6615C72.4743 39.0691 73.1334 39.7281 73.1334 40.5412V107.548Z",
    fill: "#F47C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1447",
    d: "M102.4 107.32H73.1333V56.1435C73.1333 55.3307 73.7926 54.6714 74.6054 54.6714H100.929C101.741 54.6714 102.4 55.3307 102.4 56.1435V107.32Z",
    fill: "#99E6FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1451",
    d: "M43.8665 108.234H14.5994V69.3058C14.5994 68.493 15.2584 67.8339 16.0712 67.8339H42.3944C43.2072 67.8339 43.8665 68.493 43.8665 69.3058V108.234Z",
    fill: "#BBEC6C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1455",
    d: "M90.6143 96.3511C87.3342 96.3511 84.6752 93.6921 84.6752 90.4117V56.1435C84.6752 55.3305 85.3342 54.6714 86.147 54.6714H74.6054C73.7926 54.6714 73.1333 55.3305 73.1333 56.1435V96.3511V107.32H84.6752H102.4V96.3511H90.6143Z",
    fill: "#62DBFB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1459",
    d: "M62.2343 96.3511C58.4643 96.3511 55.4081 93.2949 55.4081 89.5249V40.5412C55.4081 39.7281 56.0671 39.0691 56.8802 39.0691H45.3383C44.5255 39.0691 43.8665 39.7281 43.8665 40.5412V96.3511V107.548H55.4081H73.1334V96.3511H62.2343Z",
    fill: "#EE6161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1463",
    d: "M32.403 96.3511C28.9447 96.3511 26.141 93.5474 26.141 90.0891V69.3058C26.141 68.493 26.8 67.8339 27.6129 67.8339H16.0712C15.2584 67.8339 14.5994 68.493 14.5994 69.3058V96.3511V108.234H26.141H43.8665V96.3511H32.403Z",
    fill: "#A2E62E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1467",
    d: "M112.555 100.921H4.44439C2.92247 100.921 1.68872 102.155 1.68872 103.677V112.859C1.68872 114.175 2.75589 115.243 4.07237 115.243H112.927C114.244 115.243 115.311 114.175 115.311 112.859V103.677C115.311 102.155 114.077 100.921 112.555 100.921Z",
    fill: "#D7D0D6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1471",
    d: "M59.7047 2.50718L63.3477 9.88893C63.5435 10.2856 63.922 10.5603 64.3596 10.6241L72.5059 11.8078C73.6078 11.9677 74.0479 13.3221 73.2504 14.0996L67.3556 19.8454C67.0391 20.1541 66.8945 20.5988 66.9692 21.0348L68.3609 29.148C68.5492 30.2456 67.397 31.0826 66.4114 30.5643L59.1252 26.734C58.7337 26.5281 58.266 26.5281 57.8745 26.734L50.5883 30.5643C49.6027 31.0826 48.4505 30.2456 48.6388 29.148L50.0305 21.0348C50.1052 20.5988 49.9606 20.1541 49.6441 19.8454L43.7493 14.0996C42.9518 13.3221 43.3919 11.9677 44.494 11.8078L52.6401 10.6241C53.0777 10.5603 53.4562 10.2856 53.652 9.88893L57.295 2.50718C57.7877 1.50857 59.212 1.50857 59.7047 2.50718Z",
    fill: "#FEE45A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1475",
    d: "M113.597 113.529H3.40259V103.677C3.40259 103.103 3.8699 102.635 4.44462 102.635H85.0249C85.9714 102.635 86.7388 101.868 86.7388 100.921C86.7388 99.9749 85.9714 99.2075 85.0249 99.2075H74.8473V56.3853H100.687V99.2075H92.3287C91.382 99.2075 90.6149 99.9749 90.6149 100.921C90.6149 101.868 91.382 102.635 92.3287 102.635H112.555C113.13 102.635 113.597 103.103 113.597 103.677V113.529ZM16.313 69.5476H42.1524V99.2073H16.313V69.5476ZM112.555 99.2075H104.114V56.1435C104.114 54.3867 102.685 52.9576 100.929 52.9576H74.8473V40.5412C74.8473 38.7843 73.4182 37.3552 71.6613 37.3552H45.3384C43.5816 37.3552 42.1527 38.7843 42.1527 40.5412V52.6868C42.1527 53.6333 42.9198 54.4006 43.8665 54.4006C44.813 54.4006 45.5804 53.6333 45.5804 52.6868V40.7829H71.4196V99.2075H45.5804V59.9906C45.5804 59.0441 44.813 58.2767 43.8665 58.2767C42.9198 58.2767 42.1527 59.0441 42.1527 59.9906V66.1198H16.0713C14.3144 66.1198 12.8853 67.5492 12.8853 69.3058V99.2075H4.44462C1.98008 99.2075 -0.0251465 101.213 -0.0251465 103.677V115.243C-0.0251465 116.189 0.742209 116.957 1.68872 116.957H115.311C116.258 116.957 117.025 116.189 117.025 115.243V103.677C117.025 101.213 115.02 99.2075 112.555 99.2075Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1479",
    d: "M52.8867 12.3197C53.8826 12.1751 54.7434 11.5496 55.1888 10.6472L58.4997 3.93823L61.8109 10.6472C62.2563 11.5496 63.1171 12.1751 64.1132 12.3197L71.5169 13.3956L66.1594 18.6181C65.4386 19.3205 65.1098 20.3322 65.28 21.3242L66.5449 28.6981L59.9229 25.2167C59.0317 24.748 57.9678 24.7482 57.077 25.2167L50.4548 28.6981L51.7199 21.3242C51.8899 20.3322 51.5611 19.3205 50.8404 18.6178L45.4828 13.3956L52.8867 12.3197ZM48.3084 20.9366L46.9499 28.8579C46.7513 30.0132 47.2172 31.1592 48.1658 31.8482C49.1141 32.5374 50.3477 32.6265 51.386 32.0813L58.4997 28.3412L65.6137 32.0813C66.0652 32.3185 66.5535 32.4357 67.0396 32.4355C67.6708 32.4355 68.2978 32.2378 68.8339 31.8482C69.7825 31.1592 70.2484 30.0132 70.0498 28.8581L68.6913 20.9366L74.4469 15.3265C75.286 14.5082 75.5826 13.3071 75.2202 12.1922C74.858 11.0773 73.9124 10.28 72.7523 10.1114L64.7985 8.95552L61.2417 1.74859C60.723 0.697193 59.6722 0.0440941 58.4997 0.0440941C57.3275 0.0440941 56.2767 0.697191 55.758 1.74836L52.2012 8.95552L44.2474 10.1114C43.0873 10.28 42.1417 11.0773 41.7795 12.1922C41.4171 13.3071 41.7134 14.5082 42.5528 15.3265L48.3084 20.9366Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1483",
    d: "M83.311 16.2397C83.311 17.1863 84.0782 17.9536 85.0249 17.9536H87.4794C88.4261 17.9536 89.1933 17.1863 89.1933 16.2397C89.1933 15.2932 88.4261 14.5259 87.4794 14.5259H85.0249C84.0782 14.5259 83.311 15.2932 83.311 16.2397Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1487",
    d: "M82.0713 5.98096C82.308 5.98096 82.5489 5.9316 82.7785 5.82739L85.0136 4.81279C85.8754 4.42157 86.257 3.40559 85.8658 2.54385C85.475 1.68212 84.4588 1.3005 83.5971 1.69149L81.362 2.70587C80.5 3.09709 80.1184 4.11307 80.5096 4.97503C80.7964 5.60711 81.4193 5.98096 82.0713 5.98096Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1491",
    d: "M81.362 29.7732L83.5971 30.7876C83.827 30.892 84.0676 30.9414 84.3044 30.9414C84.9563 30.9414 85.5792 30.5676 85.866 29.9353C86.2573 29.0735 85.8756 28.0575 85.0137 27.6663L82.7786 26.6519C81.9161 26.2609 80.9004 26.6426 80.5099 27.5043C80.1186 28.366 80.5003 29.382 81.362 29.7732Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1495",
    d: "M29.7488 17.9536H32.2033C33.15 17.9536 33.9171 17.1863 33.9171 16.2397C33.9171 15.2932 33.15 14.5259 32.2033 14.5259H29.7488C28.802 14.5259 28.0349 15.2932 28.0349 16.2397C28.0349 17.1863 28.802 17.9536 29.7488 17.9536Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1499",
    d: "M32.2145 4.81327L34.4496 5.82765C34.6795 5.93209 34.9202 5.98145 35.1569 5.98145C35.8089 5.98145 36.4318 5.60759 36.7186 4.97529C37.1098 4.11356 36.7282 3.09758 35.8662 2.70636L33.6311 1.69198C32.7685 1.30076 31.7529 1.68261 31.3624 2.54434C30.9712 3.40607 31.3528 4.42205 32.2145 4.81327Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1503",
    d: "M34.4499 26.6519L32.2148 27.6663C31.3528 28.0575 30.9712 29.0735 31.3624 29.9355C31.6492 30.5676 32.2723 30.9414 32.9241 30.9414C33.1608 30.9414 33.4017 30.892 33.6313 30.7878L35.8664 29.7732C36.7284 29.382 37.11 28.366 36.7188 27.5043C36.3278 26.6423 35.3118 26.2612 34.4499 26.6519Z",
    fill: "black"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_2283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 117,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingGraphIcon);
export default __webpack_public_path__ + "static/media/ranking-graph-icon.33036f489f804897e0c41af8781f0d43.svg";
export { ForwardRef as ReactComponent };